// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import { ComponentLocale } from '..';
import en_US from './en-US/strings.json';

/**
 * Locale for English (US).
 *
 * @public
 */
export const COMPONENT_LOCALE_EN_US: ComponentLocale = {
  strings: en_US
};